
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personvern",
      function () {
        return require("private-next-pages/personvern.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personvern"])
      });
    }
  